import { isAdminApp } from '~/public/lib/PageHelpers';
import { useBusinessInfo } from '~/lib/Queries';
import { useContext } from 'react';
import { FormContext } from '~/components/forms/FormContext';
import { ConfirmationContext } from '~/lib/ConfirmationContext';

const useCurrentBusiness = () => {
    if (isAdminApp()) {
        const { data } = useBusinessInfo();
        return data?.business;
    } else {
        // Try the form
        const formContext = useContext(FormContext);
        const confirmationContext = useContext(ConfirmationContext);

        if (formContext?.form) {
            return formContext?.form?.business;
        } else {
            // Try confirmation context
            return confirmationContext?.submission?.form?.business;
        }
    }
};

export default useCurrentBusiness;
